import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  CircularProgress,
  Divider,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { CommonStyles } from "../../commons/CommonStyles";
import {
  GetProfileUser,
} from "../../services/ReasonService";
import {
  GetMasterTypeVerification,
  GetMasterTypeVerificationDescription,
  GetMasterCountry,
  GetMasterTypeUserDocument,
  GetMasterPhonePrefix,
} from "../../services/MasterCallsService";
import { AttributeCodes, Attributes } from "../../commons/Attributes";
import { DialogDelete } from "../VerificationComponents/DialogDelete";
import { DialogResetPassword } from "../VerificationComponents/DialogResetPassword";
import { Alerts } from "../Alerts/Alerts";
// import { ActionsCard } from "../VerificationComponents/ActionsCard";
import { checkIsNullUndefined, getCountryByAnyIdValue, getErrorMessage } from "../../commons/Utils";
import { Constants } from "../../commons/Constants";
import { CorreosButton } from "../../components/CorreosButton/CorreosButton";
import { useTranslation } from "react-i18next";
import { DialogShowAddress } from "../CommonComponents/Dialogs/DialogShowAddress";
import { controlUserMovement, getReplaceMode, getSessionItem, setSessionItem } from "../../services/Commons";
import { SecondFACard } from "../VerificationComponents/SecondFACard";
import { isResultOk, showAlert } from "../../commons/FormManager";
import history from "../../services/history.js";
import { EnumPages } from "../../commons/EnumPages.js";
import { CorreosIcon } from "../CommonComponents/CorreosIcon/CorreosIcon.js";
import { iconNames } from "../../commons/EnumsGeneral.js";
import { DialogVerifications } from "../VerificationComponents/DialogVerifications.js";

export function UserVerifications() {
  const commonClasses = CommonStyles();
  const { t } = useTranslation();

  const [circularProgress, setCircularProgress] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });
  const [openReset, setOpenReset] = useState(false);
  const [auxVerifyList, setAuxVerifyList] = useState([]);
  const [userEmails, setUserEmails] = useState([]);
  const [userPhones, setUserPhones] = useState([]);
  const [userDocuments, setUserDocuments] = useState([]);
  const [userAddresses, setUserAddresses] = useState([]);
  const [masterCountryList, setMasterCountryList] = useState([]);
  const [masterCountryPrefixList, setMasterCountryPrefixList] = useState([]);
  const [masterTypeUserDocument, setMasterTypeUserDocument] = useState([]);
  const [hasVerifiedPhones, setHasVerifiedPhones] = useState(false);
  const [preOpen, setPreOpen] = useState(false);
  const [openChange, setOpenChange] = useState(false);
  const [verificable, setVerificable] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [operationType, setOperationType] = useState(null);

  useEffect(() => {
    let auxIs2FA = getSessionItem("2FA");
    if (auxIs2FA == "true") {
      setSessionItem("2FA", "false");
      setPreOpen(true);
    };
    if (masterCountryPrefixList.length === 0) {
      GetMasterPhonePrefix().then((response) => {
        if (response && !response.Status) {
          setMasterCountryPrefixList(response);
        } else {
          finishOperation("error", getErrorMessage(response, t));
        };
      });
    };
    chargePageData();
  }, []);

  useEffect(() => {
    let userVerifiedPhone = userPhones.find((phone) => phone.idConTypeVerification >= 5);
    setHasVerifiedPhones(!checkIsNullUndefined(userVerifiedPhone));
  }, [userPhones]);

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };

  const getVerificableName = (verificable, tipo) => {
    let auxName = verificable[Attributes[tipo].attributeName];
    if (tipo === AttributeCodes.Phone) {
      let country = getCountryByAnyIdValue(masterCountryList, verificable.idCountry, "id");
      auxName = country.phonePrefix + "-" + auxName;
    };
    return auxName;
  };

  const chargePageData = () => {
    setCircularProgress(true);
    let getMasterTypeVerificationDescription = GetMasterTypeVerificationDescription();
    let getMasterTypeVerification = GetMasterTypeVerification();
    let getProfileUser = GetProfileUser();
    let getMasterCountry = GetMasterCountry();
    let getMasterTypeUserDocument = GetMasterTypeUserDocument();
    Promise.all([getMasterTypeVerificationDescription, getMasterTypeVerification, getProfileUser, getMasterCountry, getMasterTypeUserDocument]).then((results) => {
      let masterVerificationDescription = results[0]
      let masterVerification = results[1];
      let profileUser = results[2];
      let masterCountryList = results[3];
      let masterUserDocumentType = results[4];
      if (isResultOk([masterVerificationDescription, masterVerification, profileUser, masterCountryList, masterUserDocumentType])) {
        setMasterCountryList(masterCountryList);
        setMasterTypeUserDocument(masterUserDocumentType);
        let tempVerifyList = [];
        masterVerification.forEach((verification) => {
          let auxVerifyObj = masterVerificationDescription.find((description) => verification.idDescription === description.id);
          if (!checkIsNullUndefined(auxVerifyObj)) {
            tempVerifyList.push({
              id: auxVerifyObj.id,
              idLevel: verification.idLevel,
              description: auxVerifyObj.name,
            });
          };
        });
        setAuxVerifyList(tempVerifyList);
        getSetVerificationLevel(tempVerifyList, profileUser.userEmail);
        getSetVerificationLevel(tempVerifyList, profileUser.userPhone);
        getSetVerificationLevel(tempVerifyList, profileUser.userDocument);
        getSetVerificationLevel(tempVerifyList, profileUser.userAddress);
        setUserEmails(profileUser.userEmail);
        setUserPhones(profileUser.userPhone);
        setUserDocuments(profileUser.userDocument);
        setUserAddresses(profileUser.userAddress);
        setCircularProgress(false);
      } else {
        showAlert([masterVerificationDescription, masterVerification, profileUser, masterCountryList, masterUserDocumentType], finishOperation, t);
      };
    });
  };

  const getSetVerificationLevel = (tempVerifyList, userDataList) => {
    userDataList.forEach((data) => {
      let auxVerifyData = tempVerifyList.find((verify) => verify.id === data.idConTypeVerification);
      if (!checkIsNullUndefined(auxVerifyData)) {
        data.idLevel = auxVerifyData.idLevel;
        data.verifyDesc = auxVerifyData.description;
      };
    });
  };

  const addVerificable = (verificable, tipo) => {
    let auxObject = getVerificableListAndSetter(tipo);
    let auxList = JSON.parse(JSON.stringify(auxObject.list));
    let auxVerificable = verificable;
    let auxSet = auxObject.setter;
    let auxIdConTypeVerification = tipo == AttributeCodes.Phone ? 5 : 2;
    let auxVerifyData = auxVerifyList.find((verify) => verify.id === auxIdConTypeVerification);
    auxVerificable.idConTypeVerification = auxIdConTypeVerification;
    auxVerificable.idLevel = auxVerifyData.idLevel;
    auxVerificable.verifyDesc = auxVerifyData.description;
    // if (auxList.length <= 1) {
    //   auxList[0] = auxVerificable;
    // } else {
    let position = auxList.findIndex((auxilVerificable) => auxilVerificable.id === auxVerificable.id);
    if (position >= 0) {
      auxList[position] = auxVerificable;
    } else {
      auxList[0] = auxVerificable;
    };
    // let originalVerificable = auxList.find((auxilVerificable) => auxilVerificable.id === auxVerificable.id);
    // if (!checkIsNullUndefined(originalVerificable)) {
    //   originalVerificable = auxVerificable;
    // };
    // };
    auxSet(auxList);
  };

  const deleteVerificable = (verificable, tipo) => {
    let auxObject = getVerificableListAndSetter(tipo);
    let auxList = auxObject.list;
    let auxSet = auxObject.setter;
    let newList = auxList.filter((auxVerificable) => auxVerificable.id !== verificable.id);
    auxSet(newList);
  };

  const getVerificableListAndSetter = (tipo) => {
    switch (tipo) {
      case AttributeCodes.Email:
        return { list: JSON.parse(JSON.stringify(userEmails)), setter: setUserEmails };
      case AttributeCodes.Phone:
        return { list: JSON.parse(JSON.stringify(userPhones)), setter: setUserPhones };
      case AttributeCodes.DocNumber:
        return { list: JSON.parse(JSON.stringify(userDocuments)), setter: setUserDocuments };
      case AttributeCodes.Alias:
        return { list: JSON.parse(JSON.stringify(userAddresses)), setter: setUserAddresses };
      default:
        break;
    };
  };

  const getIcon = (tipo, escala) => {
    switch (tipo) {
      case AttributeCodes.Email:
        return <CorreosIcon iconSelected={iconNames.email} iconName="Email Icon" iconState="basic" iconScale={escala} />;
      case AttributeCodes.Phone:
        return <CorreosIcon iconSelected={iconNames.phone} iconName="Phone Icon" iconState="basic" iconScale={escala} />;
      case AttributeCodes.DocNumber:
        return <CorreosIcon iconSelected={iconNames.document} iconName="Card Icon" iconState="basic" iconScale={escala} />;
      case AttributeCodes.Alias:
        return <CorreosIcon iconSelected={iconNames.address} iconName="Home Icon" iconState="basic" iconScale={escala} />;
      default:
        break;
    }
  };

  const buildDeleteVerificable = (verificable, fromList, tipo) => {
    let auxVerificable;
    if (fromList) {
      auxVerificable = verificable;
    } else {
      auxVerificable = getVerificableListAndSetter(tipo).list.find((auxilVerificable) => auxilVerificable.id == verificable);
    };
    return (
      <DialogDelete
        verificable={auxVerificable}
        tipo={tipo}
        finishOperation={finishOperation}
        getVerificableName={getVerificableName}
        deleteVerificable={deleteVerificable}
        masterTypeUserDocument={masterTypeUserDocument}
        userEmails={userEmails}
      />
    );
  };

  const buildVerifyChange = (verificable, tipo, verified) => {
    let auxList = tipo === AttributeCodes.Email ? userEmails : userPhones;
    let auxOperationType = (auxList.length == 1 && verified) ? "change" : "verify";
    let auxTitle = auxOperationType == "change" ? t("change") : t("verificationsVerify");
    let auxIcon = auxOperationType == "change" ? iconNames.change : iconNames.verify;
    return (
      <>
        <Tooltip title={auxTitle}>
          <IconButton
            className={commonClasses.iconButton}
            aria-label="menu"
            onClick={() => handleVerifyChange(auxOperationType, verificable, tipo)}
          >
            <CorreosIcon iconSelected={auxIcon} iconName="VeryChange Icon" iconState="enabled" iconScale={1.75} />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const handleVerifyChange = (auxOperationType, auxVerificable, auxTipo) => {
    setOperationType(auxOperationType);
    setVerificable(auxVerificable);
    setTipo(auxTipo);
    setOpenChange(true);
  };

  const buildListCard = (verifyList, tipo) => {
    return (
      <Grid
        item
        container
        spacing={1}
        md={12}
        className={commonClasses.listStyle}
      >
        <Grid item xs={12} style={{ display: "flex", textAlign: "left", padding: "0.5em 0", marginTop: "1.5em" }}>
          {getIcon(tipo, "2.5")}
          <Typography variant="h6" style={{ margin: "auto auto auto 0.5em" }}>{t("verifications" + tipo)}</Typography>
        </Grid>
        {buildInfoList(verifyList, tipo)}
      </Grid>
    );
  };

  const buildInfoList = (list, tipo) => {
    let auxVerifiedList = list.filter((verificable) => verificable.idLevel >= Constants.lvlVerification.medium);
    auxVerifiedList.forEach((verificable) => { verificable.verified = true });
    let auxNotVerifiedList = list.filter((verificable) => verificable.idLevel < Constants.lvlVerification.medium);
    auxNotVerifiedList.forEach((verificable) => { verificable.verified = false });
    let auxList = auxVerifiedList.concat(auxNotVerifiedList);
    return (
      <>
        {auxList.length == 0 ? (
          <Grid container item xs={12}>
            <Grid item xs={12}>
              <Typography className={commonClasses.listTextStyleShow}>
                {t("verificationsEmpty")}
              </Typography>
            </Grid>
          </Grid >
        ) : (
          <>
            {auxList.map((verificable, index) => {
              return infoListForm(tipo, verificable, verificable.verified, index);
            })}
          </>
        )}
      </>
    );
  };

  const infoListForm = (tipo, verificable, verified, index) => {
    return (
      <Grid item container xs={12} key={tipo + index} className={index % 2 == 0 ? commonClasses.evenRow : commonClasses.oddRow} style={{ display: "flex" }}>
        <Grid item xs={12} sm={6} className={commonClasses.tableRow}>
          <Typography className={commonClasses.listTextStyleShow} noWrap>
            {getVerificableName(verificable, tipo)}
          </Typography>
        </Grid>
        <Grid item xs={10} sm={4} className={commonClasses.tableRow}>
          <Typography
            className={
              verified
                ? commonClasses.listTextStyleGreen
                : commonClasses.listTextStyleOrange
            }
          >
            {verificable.verifyDesc}
          </Typography>
        </Grid>
        {tipo === AttributeCodes.Alias ? (
          <Grid item xs={1} className={commonClasses.iconGridStyle}>
            <DialogShowAddress address={verificable} isUser={true} />
          </Grid>
        ) : (
          <Grid item xs={1}>
            {checkNeedForIcon(tipo, verified) && buildVerifyChange(verificable, tipo, verified)}
          </Grid>
        )}
        <Grid item xs={1} className={commonClasses.iconGridStyle} >
          {buildDeleteVerificable(verificable, true, tipo)}
        </Grid>
      </Grid>
    );
  };

  const checkNeedForIcon = (tipo, verified) => {
    let auxFlag = false;
    if (tipo === AttributeCodes.Email || tipo === AttributeCodes.Phone) {
      let auxList = tipo === AttributeCodes.Email ? userEmails : userPhones;
      if (!verified || auxList.length == 1) {
        auxFlag = true;
      }
    }
    return auxFlag;
  };

  const handleResetPassword = () => {
    setOpenReset(true);
  };

  const buildSecondFACard = () => {
    let emailsList = getVerifiedValues(AttributeCodes.Email);
    let emailsNames = emailsList.map((email) => email.email);
    return <SecondFACard
      finishOperation={finishOperation}
      emails={emailsNames}
      hasVerifiedPhones={hasVerifiedPhones}
      addVerificable={addVerificable}
      preOpen={preOpen}
      setPreOpen={setPreOpen}
      masterCountryPrefixList={masterCountryPrefixList}
    />;
  };

  const getVerifiedValues = (tipo) => {
    let auxList = getVerificableListAndSetter(tipo).list;
    let auxVerifiedList = auxList.filter((verificable) => verificable.idLevel >= Constants.lvlVerification.medium);
    return auxVerifiedList;
  };

  const goToUnifyAccounts = () => {
    let redirect = "/" + EnumPages.Index + "/" + EnumPages.UnifyAccounts;
    history.push(redirect);
  };

  return (
    <Grid>
      <Alerts alert={alert} setAlert={setAlert}></Alerts>
      <Grid
        container
        spacing={1}
      >
        <Grid
          item
          xs={12}
          container
          spacing={1}
          className={commonClasses.actionCardsContainer}
        >
          {circularProgress ? (
            <CircularProgress className={commonClasses.circularProgress} />
          ) : (
            <Grid item md={12} xs={12}>
              {buildSecondFACard()}
              {/* {buildActionsCard(userEmails, AttributeCodes.Email)}
              {buildActionsCard(userPhones, AttributeCodes.Phone)} */}
            </Grid>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={1}
        >
          {circularProgress ? (
            <CircularProgress className={commonClasses.circularProgress} />
          ) : (
            <Grid item xs={12}>
              <Grid item md={12} xs={12}>
                <Divider className={commonClasses.pageCategoryDivider}></Divider>
              </Grid>
              <Grid
                container
                style={{ textAlign: "center" }}
                spacing={1}
                alignItems="flex-end"
              >
                {buildListCard(
                  userEmails,
                  AttributeCodes.Email
                )}
                {buildListCard(
                  userPhones,
                  AttributeCodes.Phone
                )}
                {buildListCard(
                  userDocuments,
                  AttributeCodes.DocNumber
                )}
                {/* {buildListCard(
                  userAddresses,
                  AttributeCodes.Alias
                )} */}
              </Grid>
              <Grid
                container
                item
                xs={12}
                className={commonClasses.dialogButtonContainer}
              >
                {/* <Grid item xs={12} sm={6}>
                  <CorreosButton
                    variant="contained"
                    color="primary"
                    onClick={goToUnifyAccounts}
                    className={commonClasses.buttonLeftCenter}
                  >
                    {t("goToUnifyAccountsButton")}
                  </CorreosButton>
                </Grid> */}
                <Grid item xs={12}>
                  <CorreosButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleResetPassword()}
                    className={commonClasses.buttonRightCenter}
                  >
                    {t("resetPassword")}
                  </CorreosButton>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      {getReplaceMode() == "true" ? (
        <Grid container spacing={1} style={{ marginTop: "1.5em" }}>
          <Grid item xs={12}>
            <CorreosButton
              onClick={() => { controlUserMovement(false, finishOperation, t) }}
              variant="contained"
              color="primary"
              className={commonClasses.dialogButtonCenter}
            >
              {t("backToTheApp")}
            </CorreosButton>
          </Grid>
        </Grid>) : null}
      <DialogResetPassword
        verifiedEmails={getVerifiedValues(AttributeCodes.Email)}
        open={openReset}
        setOpen={setOpenReset}
        setAlert={setAlert}
      />
      <DialogVerifications
        open={openChange}
        setOpen={setOpenChange}
        verificable={verificable}
        type={tipo}
        finishOperation={finishOperation}
        getVerificableName={getVerificableName}
        operationType={operationType}
        masterCountryList={masterCountryList}
        addVerificable={addVerificable}
        masterCountryPrefixList={masterCountryPrefixList}
      />
    </Grid>
  );
}
